import React, { useState, useEffect } from 'react';
import { Button } from '@mui/material';
import DialogModal from '../../../components/DialogModal';
import DropdownSelect from '../../../components/DropdownSelect';
import TextInputWithIcon from '../../../components/TextInputWithIcon';
import { StyledButton } from '../../Exams/styled';
import { AddSubSkillFormContainer } from '../styled';
import { AddSubSkillModalProps, SubSkillResponse } from '../types';

const AddSubSkillModal: React.FC<AddSubSkillModalProps> = ({
  open,
  onClose,
  onAddSubSkill,
  scoringTypeOptions,
  isLoadingScoringTypes
}) => {
  const [description, setDescription] = useState('');
  const [scoringTypeId, setScoringTypeId] = useState('');
  const [order, setOrder] = useState('');
  const [maxMarks, setMaxMarks] = useState('');

  useEffect(() => {
    if (open) {
      setDescription('');
      setScoringTypeId('');
      setOrder('');
      setMaxMarks('');
    }
  }, [open]);

  const selectedScoringType = scoringTypeOptions.find(
    (st) => st.id === scoringTypeId
  );
  const showMaxMarks =
    !!scoringTypeId &&
    (!selectedScoringType?.validScores ||
      selectedScoringType.validScores.length === 0);

  useEffect(() => {
    if (!showMaxMarks) {
      setMaxMarks('');
    }
  }, [showMaxMarks]);

  const handleAdd = () => {
    const scoringTypeObj = scoringTypeOptions.find(
      (st) => st.id === scoringTypeId
    );
    const newSubSkill: SubSkillResponse = {
      id: `temp-${Date.now()}`,
      description,
      scoringType: scoringTypeObj
        ? {
            id: scoringTypeObj.id!,
            name: scoringTypeObj.name,
            validScores: scoringTypeObj.validScores || []
          }
        : scoringTypeId,
      order: Number(order) || 0,
      ...(maxMarks !== '' ? { maxMarks: Number(maxMarks) } : {})
    };
    onAddSubSkill(newSubSkill);
    onClose();
  };

  const isAddDisabled =
    !description || !scoringTypeId || !order || (showMaxMarks && !maxMarks);

  return (
    <DialogModal
      open={open}
      onClose={onClose}
      title='Add Sub-Skill'
      actions={
        <>
          <Button onClick={onClose} color='primary' variant='outlined'>
            Cancel
          </Button>
          <StyledButton onClick={handleAdd} disabled={isAddDisabled}>
            Add
          </StyledButton>
        </>
      }
    >
      <AddSubSkillFormContainer>
        <TextInputWithIcon
          label='Description'
          placeholder='Enter Description'
          required
          name='description'
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          fullWidth
        />
        <DropdownSelect
          label='Scoring Type'
          placeholder='Select Scoring Type'
          required
          name='scoringType'
          value={scoringTypeId}
          options={scoringTypeOptions.map((st) => ({
            value: st.id || '',
            label: st.name
          }))}
          onChange={(e) => setScoringTypeId(e.target.value as string)}
          loading={isLoadingScoringTypes}
        />
        <TextInputWithIcon
          label='Order'
          placeholder='Order'
          required
          name='order'
          value={order}
          onChange={(e) => setOrder(e.target.value)}
          fullWidth
        />
        {showMaxMarks && (
          <TextInputWithIcon
            label='Max Marks'
            placeholder='Enter Max Marks'
            required
            name='maxMarks'
            value={maxMarks}
            onChange={(e) => setMaxMarks(e.target.value)}
            fullWidth
            type='number'
          />
        )}
      </AddSubSkillFormContainer>
    </DialogModal>
  );
};

export default AddSubSkillModal;
